'use strict';exports.__esModule = true;var validate = function validate(values) {
  var errors = {};

  if (!values.name || !values.name.length) {
    errors.name = 'emptyField';
  }

  var licenseNumberLength = values.license_number ? values.license_number.length : 0;

  if (licenseNumberLength && licenseNumberLength < 4) {
    errors.license_number = 'licenseNumberMinLength';
  }

  return errors;
};exports.default =

validate;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/MyStaffEmployeesCard/validate.js
// module id = 2744
// module chunks = 0